import { Validators } from "@angular/forms";
import {ResponseCode} from "../constant/response-code";
import {ToastrService} from "ngx-toastr";
import {UrlsConstant} from '../../shared/add-refresh/constant/urls-constant.enum';
import {UserModal} from '../../modules/user/modal/user-modal';
import {ModuleUrlsConstant} from "../../shared/add-refresh/constant/module-urls-constant";

export class AbstractBaseDetailsComponent {
    public urls = UrlsConstant;
    public isUserAllow: boolean;
    public activeUser: UserModal;
    public propertyUrls = ModuleUrlsConstant;

    constructor(
        public toaster: ToastrService
        ) {
        this.authRole();
    }


    public numberOnlyValidation  = Validators.pattern(/^\d*(?:[.,]\d{1,4})?$/);

    keypress(event: any) {
        const pattern = /[0-9\.]/;
        let inputChar = String.fromCharCode(event.charCode);
        if (event.keyCode != 8 && event.keyCode != 9 && !pattern.test(inputChar)) {
            event.preventDefault();
        }
    }

    public validateResponse(response, fun: Function) {
        if (response.responseCode !== ResponseCode.OK) {
            this.toaster.error(response.responseMessage,'Error');
            return;
        }

        fun();
    }

    public authRole() {
        // Id 1 for admin, Id 2 for staff, Id 3 for SuperAdmin, Id 4 for other.
        this.activeUser = JSON.parse(localStorage.getItem('activeUser'));
        if (this.activeUser && this.activeUser.role && this.activeUser.role.roleid) {
            if (this.activeUser.role.roleid === 1 || this.activeUser.role.roleid === 3) {
                this.isUserAllow = true;
            }
            if (this.activeUser.role.roleid === 2 || this.activeUser.role.roleid === 4) {
                this.isUserAllow = false;
            }
        }
    }
}
